import i18n from '@/i18n';
import { ENV } from '@/infrastructure/env-config';
import { FilterOptions } from '@/proto/alert';

export const ALERT_CHANNELS_OPTIONS: FilterOptions[] = [
  { value: 0, label: i18n.t('所有') },
  { value: 1, label: i18n.t('邮件') },
  { value: 2, label: i18n.t('短信') },
  { value: 3, label: i18n.t('电话') },
  { value: 4, label: i18n.t('企业微信') },
];

export const ALERT_CHANNELS_OPTIONS_PRO: FilterOptions[] = [
  { value: 0, label: i18n.t('所有') },
  { value: 1, label: i18n.t('电子邮箱') },
  { value: 4, label: i18n.t('微信公众号'), hidden: ENV.isGlobal },
];
